export default __webpack_public_path__ + "static/media/pmmmlogo.bcdb758a.png";